import { killEvent } from '@medplum/react'
import { cn } from '@seen/ui'
import type { JSX } from 'react'
import { Checkbox } from '#src/components/core/Checkbox.tsx'

export interface TaskRowCheckboxProps {
  value?: boolean
  onChange?: (value: boolean, isShiftClick?: boolean) => void
}

export function TaskRowCheckbox({
  value,
  onChange,
}: TaskRowCheckboxProps): JSX.Element {
  return (
    <div
      onClick={(e) => {
        killEvent(e)
        const isShiftClick = e.shiftKey
        onChange?.(!value, isShiftClick)
      }}
      className="flex w-8 max-w-8 min-w-8 items-center justify-center self-stretch"
    >
      <Checkbox
        className={cn(
          'opacity-0 group-hover:opacity-100',
          value && 'opacity-100'
        )}
        value={value}
        onChange={(newValue) => onChange?.(newValue)}
      />
    </div>
  )
}
